// extracted by mini-css-extract-plugin
export default {"centeredModal":"facebook_centeredModal__aRPjD","errorMessage":"facebook_errorMessage__9G4zK"};